/**
 * @desc 退件入库
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.LogisticsReturnCreateInDto, options?: any) {
  return updateResponse(
    http(URL + `/logisticsReturnRecord/logisticsCreateIn`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
